module.exports = __webpack_public_path__ + "static/img/buy-img.a96af37.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy-img.png
// module id = 3C5f
// module chunks = 1